import React from 'react';
import Page from '../components/Page';

const Equipe = (props) => {
   return(
      <Page bg="/assets/img/equipe-bg.jpg">
         <h1>Equipe</h1>
         <ul>
            <li><strong>Hackers:</strong> Bárbara Pires, Luziana Assunção, Paola Sanchez, Vitor Diniz</li>
            <li><strong>Designer:</strong> Silvia Batalha</li>
            <li><strong>Mentoria:</strong> David Soeiro Barbosa</li>
            <li><strong>Revisão e validação:</strong> Carlos Leonardo Figueiredo Cunha</li>
            <li><strong>Assessoria Jurídica:</strong> Samuel Duarte</li>
            <li><strong>Validação:</strong> Felipe Ridolfi (médico infectologista), Raquel Soeiro (enfermeira)</li>
         </ul>
      </Page>
   )
}

export default Equipe;